import debounce from 'just-debounce-it';
import { useContext, useState } from 'react';
import styled from 'styled-components';
import TipTapEditorV3 from '@/components/TipTapEditorV3/TipTapEditorV3';
import { EditorType } from '@/Enums/enum';
import useSaveDraft from '@/hooks/useSaveDraft';
import { TrashCanIcon } from '@/icons/index';

import CourseEditContext from '../CourseEditContext';

import { StyledActions } from './CourseOutcomeTab.Styles';

const StyledOutcomeEditor = styled.div`
	align-items: center;
	display: grid;
	grid-template-columns: 1fr 60px;
	margin-bottom: var(--spacing-6);
	width: 100%;
`;

interface OutcomeProps {
	onRemoveEvent(id: string): void;
	id: string;
	text: string;
}

const OutcomeEditor = ({ onRemoveEvent, id, text }: OutcomeProps) => {
	const { canEdit, isApprovalMode, updateCourseReducer, saveDraft } = useContext(CourseEditContext);

	const removeOutcome = (outcomeId: string) => {
		onRemoveEvent(outcomeId);
	};

	const [isCommented, setIsCommented] = useState(false);
	const saveAfterCommenting = (value: string) => {
		updateCourseReducer({ id, debouncedText: value }, EditorType.OUTCOME);
		setIsCommented(!isCommented);
	};
	useSaveDraft(isCommented, saveDraft, setIsCommented);

	const onOutcomeChange = debounce((value: string) => {
		updateCourseReducer({ id, debouncedText: value }, EditorType.OUTCOME);
	}, 500);

	return (
		<StyledOutcomeEditor>
			<TipTapEditorV3
				content={text}
				onChange={onOutcomeChange}
				placeholder="Add course outcome..."
				type={`${EditorType.OUTCOME}-${id}`}
				isEditable={canEdit || !isApprovalMode}
				id={id}
				commentAddedCallback={saveAfterCommenting}
				compact
			/>
			{canEdit && !isApprovalMode && (
				<StyledActions>
					<TrashCanIcon passedEvent={() => removeOutcome(id)} />
				</StyledActions>
			)}
		</StyledOutcomeEditor>
	);
};

export default OutcomeEditor;
